import {Quantity} from "src/model/Quantity";
import {PricePerUom} from "src/model/support/PricePerUom";

export class SupportProduct {
    orderLineNumber: number;
    cug: string;
    cui: string;
    label: string;
    thumbnail: string;
    origin: string;
    processedQuantity: number;
    missingQuantity: number;
    measures: Quantity[];
    pricePerUom: PricePerUom;
}